import { twMerge } from 'tailwind-merge';

interface WarningTagProps {
  text: string;
  icon: React.ReactNode;
  containerClassName?: string;
  textClassName?: string;
}

export const WarningTag = ({
  text,
  icon,
  containerClassName,
  textClassName,
}: WarningTagProps) => {
  return (
    <div
      className={twMerge(
        'flex items-center gap-3 px-4 py-1.5 bg-blue-E9F1FB border border-dashed border-primary rounded',
        containerClassName,
      )}
    >
      {icon}
      <p className={twMerge('text-2sm font-semibold', textClassName)}>{text}</p>
    </div>
  );
};
